/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinOverview.vue?vue&type=template&id=0afb00a2&scoped=true"
import script from "./digitalTwinOverview.vue?vue&type=script&lang=js"
export * from "./digitalTwinOverview.vue?vue&type=script&lang=js"
import style0 from "./digitalTwinOverview.vue?vue&type=style&index=0&id=0afb00a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb00a2",
  null
  
)

export default component.exports